import React, { Component } from 'react';
import { LlegendaFooterWrapper, CleanLlegenda, ExpandButton, ShrinkButton, EyeMasterButton } from './LlegendaFooterElement';
import { getTranslatedKey } from '../../Utils/TranslateUtils';
import { displayComponents } from '../../Utils/VisorsUtils';
import {
  NetejaLlegendaIcon,
  ExpandLlegendaIcon,
  ShrinkLlegendaIcon,
  OcultarCapesLlegendaIcon,
  MostrarCapesLlegendaIcon
} from './LlegendaFooterIcons';

export class LlegendaFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisibilityActive: false
    };
  }

  /**
   * @desc funcion para dejar la leyenda sin ninguna capa
   */
  clearLlegenda = () => {
    if (this.props.arrayLayers.length !== 0) {
      this.props.arrayLayers.forEach((capa, i) => {
        capa.setChecked(false);
        capa.setExpanded(false);
        capa.setTransPopUpOpen(false);
        capa.setVisible(true);
        capa.setExportOpen(false);
        capa.setStylesOpen(false);
        capa.setFiltresOpen(false);
        this.props.map.removeLayer(capa.getOLLayer());
        capa.getOLLayer().setOpacity(100 / 100);
        capa.setStyleSelected(0);
        capa.setOLLayer(undefined);
      });
    }
    this.props.filterVector.getSource().clear();
    this.props.deleteTaula('all');
    this.props.arrayLayers.length = 0;
    this.props.arrayExternalLayers.length = 0;
    this.props.onClickInfoPunt('close');
    this.props.shrinkAll();
    this.props.handleDeleteLayer();
  };

  toggleVisibility = (bool) => {
    this.setState({ isVisibilityActive: bool });
    this.props.arrayLayers.forEach((layer) => {
      layer.setVisible(bool);
      layer.getOLLayer().setVisible(bool);
      this.props.handleEraseInfoCard(layer);
    });
  };

  render = () => {
    return (
      <LlegendaFooterWrapper>
        {displayComponents.llegendaClear && displayComponents.cataleg && (
          <CleanLlegenda onClick={() => this.clearLlegenda()} title={getTranslatedKey('netejaLlegenda')} className="clean-llegenda">
            <NetejaLlegendaIcon isFontSizeEnabled={this.props.isFontSizeEnabled} />
          </CleanLlegenda>
        )}
        {displayComponents.llegendaExpand && (
          <>
            <ExpandButton
              title={getTranslatedKey('expandLlegenda')}
              className="expand-llegenda"
              onClick={() => this.props.expandAll()}
              onMouseEnter={() => this.setState({ isExpandAllHover: true })}
              onMouseLeave={() => this.setState({ isExpandAllHover: false })}>
              <ExpandLlegendaIcon isFontSizeEnabled={this.props.isFontSizeEnabled} />
            </ExpandButton>
            <ShrinkButton className="shrink-llegenda" title={getTranslatedKey('contractLlegenda')} onClick={() => this.props.shrinkAll()}>
              <ShrinkLlegendaIcon isFontSizeEnabled={this.props.isFontSizeEnabled} />
            </ShrinkButton>
          </>
        )}
        {displayComponents.llegendaHide && (
          <>
            <EyeMasterButton
              onClick={() => this.toggleVisibility(false)}
              title={getTranslatedKey('llegendaHide')}
              onMouseEnter={() => this.setState({ isVisibilityFalseHover: true })}
              onMouseLeave={() => this.setState({ isVisibilityFalseHover: false })}>
              <OcultarCapesLlegendaIcon isFontSizeEnabled={this.props.isFontSizeEnabled} />
            </EyeMasterButton>
            <EyeMasterButton
              onClick={() => this.toggleVisibility(true)}
              title={getTranslatedKey('llegendaShow')}
              onMouseEnter={() => this.setState({ isVisibilityTrueHover: true })}
              onMouseLeave={() => this.setState({ isVisibilityTrueHover: false })}>
              <MostrarCapesLlegendaIcon fontSizeEnabled={this.props.fontSizeEnabled} isVisibilityTrueHover={this.state.isVisibilityTrueHover}>
                <path d="M101.9,3.1h308.3c54.5,0.1,98.7,44.3,98.8,98.8v308.3c-0.1,54.5-44.3,98.7-98.8,98.8H101.9c-54.5,0-98.7-44.2-98.8-98.7V101.9C3.2,47.4,47.4,3.2,101.9,3.1z M258.5,203.3c27.1,0,49.1,22,49.1,49.1s-22,49.1-49.1,49.1s-49.1-22-49.1-49.1S231.4,203.3,258.5,203.3 M258.5,129.7c81.8,0,151.7,50.9,180,122.7c-28.3,71.8-98.2,122.7-180,122.7s-151.7-50.9-180-122.7C106.8,180.6,176.7,129.7,258.5,129.7 M114.2,252.4c27,55,82.8,90,144.3,90s117.3-35,144.3-90c-27-55-82.8-90-144.3-90S141.2,197.4,114.2,252.4z"></path>
              </MostrarCapesLlegendaIcon>
            </EyeMasterButton>
          </>
        )}
      </LlegendaFooterWrapper>
    );
  };
}
